import { MouseEvent } from 'react';
import styled from 'styled-components';
import {
  blackTangaroa,
  lima,
  paradigmLightBlue,
  razzmatazz,
} from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

const ORDER_ACTION_WIDTH = 438;

export const QuoteActionContainer = styled.div`
  position: relative;
  display: grid;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  grid-template-columns: 140px 438px 140px;
  grid-template-areas: 'qsell quotes qbuy';

  span,
  svg {
    margin: unset;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    background: ${blackTangaroa};
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'quotes quotes'
      'qsell  qbuy';
    padding: 0 16px;
    width: 100%;
  }
`;

export const BoughtLabel = styled.span.attrs({ children: 'Bought' })`
  font-size: 12px;
  color: ${lima};
`;

export const SoldLabel = styled.span.attrs({ children: 'Sold' })`
  font-size: 12px;
  color: ${razzmatazz};
`;

export const DeskLabel = styled.div`
  color: ${paradigmLightBlue};
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  text-align: center;
`;

export const DeskName = styled(DeskLabel)`
  height: 15px;
  display: inline-flex;
  align-self: center;
  justify-content: center;
  font-size: 12px;
  opacity: 0.8;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 15px;
  }
`;

export const Divider = styled.div`
  background-color: ${blackTangaroa};
  position: relative;
  width: ${ORDER_ACTION_WIDTH}px;
  height: 1px;
  margin: auto;

  &:before {
    content: '';
    display: block;
    position: absolute;
    background: linear-gradient(
      90deg,
      rgba(54, 121, 221, 0) 0%,
      rgba(54, 121, 221, 1) 50%,
      rgba(54, 121, 221, 0) 100%
    );
    opacity: 0.5;
    width: 100%;
    height: 1px;
    left: 0;
    right: 0;
    top: 0;
  }
`;

export const stopPropagation =
  (fn?: () => void) => (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    fn?.();
  };

export const MainRow = styled(QuoteActionContainer)<{
  isExpanded: boolean;
  isViewDetails?: boolean;
}>`
  align-items: ${(props) => (props.isExpanded ? 'start' : 'center')};
  height: auto;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: ${(props) => (props.isViewDetails === true ? '100px;' : '100%')};
    padding-top: 0.5rem;
    overflow-x: hidden;
  }
`;
